import React, { useState, useEffect } from 'react';
import '../styles/PredictorPage.css';

// 所有模型覆盖元素的并集
const AVAILABLE_ELEMENTS = [
  'Ag', 'Al', 'As', 'Au', 'B', 'Be', 'Bi', 'C', 'Ca', 'Cd', 'Ce', 'Co', 'Cr', 'Cu',
  'Er', 'Fe', 'Ga', 'Gd', 'Ge', 'H', 'Hf', 'In', 'Ir', 'La', 'Li', 'Mg', 'Mn', 'Mo',
  'N', 'Nb', 'Nd', 'Ni', 'O', 'P', 'Pb', 'Pd', 'Pr', 'Pt', 'Re', 'Rh', 'Ru', 'S',
  'Sb', 'Sc', 'Se', 'Si', 'Sn', 'Sr', 'Ta', 'Te', 'Th', 'Ti', 'V', 'W', 'Y', 'Zn', 'Zr'
];

// Element information data
const ELEMENT_INFO = {
  'H': { name: 'Hydrogen', number: 1, mass: 1.008 },
  'He': { name: 'Helium', number: 2, mass: 4.003 },
  'Li': { name: 'Lithium', number: 3, mass: 6.941 },
  'Be': { name: 'Beryllium', number: 4, mass: 9.012 },
  'B': { name: 'Boron', number: 5, mass: 10.811 },
  'C': { name: 'Carbon', number: 6, mass: 12.011 },
  'N': { name: 'Nitrogen', number: 7, mass: 14.007 },
  'O': { name: 'Oxygen', number: 8, mass: 15.999 },
  'F': { name: 'Fluorine', number: 9, mass: 18.998 },
  'Ne': { name: 'Neon', number: 10, mass: 20.180 },
  'Na': { name: 'Sodium', number: 11, mass: 22.990 },
  'Mg': { name: 'Magnesium', number: 12, mass: 24.305 },
  'Al': { name: 'Aluminum', number: 13, mass: 26.982 },
  'Si': { name: 'Silicon', number: 14, mass: 28.086 },
  'P': { name: 'Phosphorus', number: 15, mass: 30.974 },
  'S': { name: 'Sulfur', number: 16, mass: 32.065 },
  'Cl': { name: 'Chlorine', number: 17, mass: 35.453 },
  'Ar': { name: 'Argon', number: 18, mass: 39.948 },
  'K': { name: 'Potassium', number: 19, mass: 39.098 },
  'Ca': { name: 'Calcium', number: 20, mass: 40.078 },
  'Sc': { name: 'Scandium', number: 21, mass: 44.956 },
  'Ti': { name: 'Titanium', number: 22, mass: 47.867 },
  'V': { name: 'Vanadium', number: 23, mass: 50.942 },
  'Cr': { name: 'Chromium', number: 24, mass: 51.996 },
  'Mn': { name: 'Manganese', number: 25, mass: 54.938 },
  'Fe': { name: 'Iron', number: 26, mass: 55.845 },
  'Co': { name: 'Cobalt', number: 27, mass: 58.933 },
  'Ni': { name: 'Nickel', number: 28, mass: 58.693 },
  'Cu': { name: 'Copper', number: 29, mass: 63.546 },
  'Zn': { name: 'Zinc', number: 30, mass: 65.380 },
  'Ga': { name: 'Gallium', number: 31, mass: 69.723 },
  'Ge': { name: 'Germanium', number: 32, mass: 72.640 },
  'As': { name: 'Arsenic', number: 33, mass: 74.922 },
  'Se': { name: 'Selenium', number: 34, mass: 78.960 },
  'Br': { name: 'Bromine', number: 35, mass: 79.904 },
  'Kr': { name: 'Krypton', number: 36, mass: 83.798 },
  'Rb': { name: 'Rubidium', number: 37, mass: 85.468 },
  'Sr': { name: 'Strontium', number: 38, mass: 87.620 },
  'Y': { name: 'Yttrium', number: 39, mass: 88.906 },
  'Zr': { name: 'Zirconium', number: 40, mass: 91.224 },
  'Nb': { name: 'Niobium', number: 41, mass: 92.906 },
  'Mo': { name: 'Molybdenum', number: 42, mass: 95.960 },
  'Tc': { name: 'Technetium', number: 43, mass: 98.000 },
  'Ru': { name: 'Ruthenium', number: 44, mass: 101.070 },
  'Rh': { name: 'Rhodium', number: 45, mass: 102.906 },
  'Pd': { name: 'Palladium', number: 46, mass: 106.420 },
  'Ag': { name: 'Silver', number: 47, mass: 107.868 },
  'Cd': { name: 'Cadmium', number: 48, mass: 112.411 },
  'In': { name: 'Indium', number: 49, mass: 114.818 },
  'Sn': { name: 'Tin', number: 50, mass: 118.710 },
  'Sb': { name: 'Antimony', number: 51, mass: 121.760 },
  'Te': { name: 'Tellurium', number: 52, mass: 127.600 },
  'I': { name: 'Iodine', number: 53, mass: 126.904 },
  'Xe': { name: 'Xenon', number: 54, mass: 131.293 },
  'Cs': { name: 'Cesium', number: 55, mass: 132.905 },
  'Ba': { name: 'Barium', number: 56, mass: 137.327 },
  'La': { name: 'Lanthanum', number: 57, mass: 138.905 },
  'Ce': { name: 'Cerium', number: 58, mass: 140.116 },
  'Pr': { name: 'Praseodymium', number: 59, mass: 140.908 },
  'Nd': { name: 'Neodymium', number: 60, mass: 144.242 },
  'Pm': { name: 'Promethium', number: 61, mass: 145.000 },
  'Sm': { name: 'Samarium', number: 62, mass: 150.360 },
  'Eu': { name: 'Europium', number: 63, mass: 151.964 },
  'Gd': { name: 'Gadolinium', number: 64, mass: 157.250 },
  'Tb': { name: 'Terbium', number: 65, mass: 158.925 },
  'Dy': { name: 'Dysprosium', number: 66, mass: 162.500 },
  'Ho': { name: 'Holmium', number: 67, mass: 164.930 },
  'Er': { name: 'Erbium', number: 68, mass: 167.259 },
  'Tm': { name: 'Thulium', number: 69, mass: 168.934 },
  'Yb': { name: 'Ytterbium', number: 70, mass: 173.054 },
  'Lu': { name: 'Lutetium', number: 71, mass: 174.967 },
  'Hf': { name: 'Hafnium', number: 72, mass: 178.490 },
  'Ta': { name: 'Tantalum', number: 73, mass: 180.948 },
  'W': { name: 'Tungsten', number: 74, mass: 183.840 },
  'Re': { name: 'Rhenium', number: 75, mass: 186.207 },
  'Os': { name: 'Osmium', number: 76, mass: 190.230 },
  'Ir': { name: 'Iridium', number: 77, mass: 192.217 },
  'Pt': { name: 'Platinum', number: 78, mass: 195.084 },
  'Au': { name: 'Gold', number: 79, mass: 196.967 },
  'Hg': { name: 'Mercury', number: 80, mass: 200.590 },
  'Tl': { name: 'Thallium', number: 81, mass: 204.383 },
  'Pb': { name: 'Lead', number: 82, mass: 207.200 },
  'Bi': { name: 'Bismuth', number: 83, mass: 208.980 },
  'Po': { name: 'Polonium', number: 84, mass: 209.000 },
  'At': { name: 'Astatine', number: 85, mass: 210.000 },
  'Rn': { name: 'Radon', number: 86, mass: 222.000 },
  'Fr': { name: 'Francium', number: 87, mass: 223.000 },
  'Ra': { name: 'Radium', number: 88, mass: 226.000 },
  'Ac': { name: 'Actinium', number: 89, mass: 227.000 },
  'Th': { name: 'Thorium', number: 90, mass: 232.038 },
  'Pa': { name: 'Protactinium', number: 91, mass: 231.036 },
  'U': { name: 'Uranium', number: 92, mass: 238.029 },
  'Np': { name: 'Neptunium', number: 93, mass: 237.000 },
  'Pu': { name: 'Plutonium', number: 94, mass: 244.000 },
  'Am': { name: 'Americium', number: 95, mass: 243.000 },
  'Cm': { name: 'Curium', number: 96, mass: 247.000 },
  'Bk': { name: 'Berkelium', number: 97, mass: 247.000 },
  'Cf': { name: 'Californium', number: 98, mass: 251.000 },
  'Es': { name: 'Einsteinium', number: 99, mass: 252.000 },
  'Fm': { name: 'Fermium', number: 100, mass: 257.000 },
  'Md': { name: 'Mendelevium', number: 101, mass: 258.000 },
  'No': { name: 'Nobelium', number: 102, mass: 259.000 },
  'Lr': { name: 'Lawrencium', number: 103, mass: 262.000 }
};

// Periodic table layout data - 包含Lanthanides和Actinides在主表中
const PERIODIC_TABLE = [
  ['H', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'He'],
  ['Li', 'Be', '', '', '', '', '', '', '', '', '', '', 'B', 'C', 'N', 'O', 'F', 'Ne'],
  ['Na', 'Mg', '', '', '', '', '', '', '', '', '', '', 'Al', 'Si', 'P', 'S', 'Cl', 'Ar'],
  ['K', 'Ca', 'Sc', 'Ti', 'V', 'Cr', 'Mn', 'Fe', 'Co', 'Ni', 'Cu', 'Zn', 'Ga', 'Ge', 'As', 'Se', 'Br', 'Kr'],
  ['Rb', 'Sr', 'Y', 'Zr', 'Nb', 'Mo', 'Tc', 'Ru', 'Rh', 'Pd', 'Ag', 'Cd', 'In', 'Sn', 'Sb', 'Te', 'I', 'Xe'],
  ['Cs', 'Ba', 'La', 'Hf', 'Ta', 'W', 'Re', 'Os', 'Ir', 'Pt', 'Au', 'Hg', 'Tl', 'Pb', 'Bi', 'Po', 'At', 'Rn'],
  ['Fr', 'Ra', 'Ac', 'Rf', 'Db', 'Sg', 'Bh', 'Hs', 'Mt', 'Ds', 'Rg', 'Cn', 'Nh', 'Fl', 'Mc', 'Lv', 'Ts', 'Og'],
  ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
  ['', '', 'Ce', 'Pr', 'Nd', 'Pm', 'Sm', 'Eu', 'Gd', 'Tb', 'Dy', 'Ho', 'Er', 'Tm', 'Yb', 'Lu', '', ''],
  ['', '', 'Th', 'Pa', 'U', 'Np', 'Pu', 'Am', 'Cm', 'Bk', 'Cf', 'Es', 'Fm', 'Md', 'No', 'Lr', '', '']
];

// 添加默认元素和值
const DEFAULT_ELEMENTS = {
  'Co': 20,
  'Cr': 20,
  'Fe': 20,
  'Mn': 20,
  'Ni': 20
};

const INPUT_MODES = {
  atomic: {
    label: 'at.%'
  },
  weight: {
    label: 'wt.%'
  }
};

function PredictorPage() {
  const [selectedElements, setSelectedElements] = useState(DEFAULT_ELEMENTS);
  const [composition, setComposition] = useState(DEFAULT_ELEMENTS);
  const [inputMode, setInputMode] = useState('atomic');
  const [prediction, setPrediction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalComposition, setTotalComposition] = useState(100);
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const isPropertySupported = (key) => prediction?.availability?.[key]?.supported;
  const getUnsupportedElementsText = (key) => {
    const reason = prediction?.availability?.[key]?.reason;
    if (!reason) return null;
    const match = reason.match(/unsupported elements:\s*(.+)/i);
    if (match) return match[1];
    return reason;
  };
  const getPropertyUnavailableMessage = (key) => {
    if (!prediction || isPropertySupported(key)) return null;
    const unsupportedElements = getUnsupportedElementsText(key);
    if (unsupportedElements) {
      return `Model not available for this property because of unsupported elements: ${unsupportedElements}.`;
    }
    return 'Model is not available for this property with the current composition.';
  };
  const renderPropertyHint = (key) => {
    const message = getPropertyUnavailableMessage(key);
    if (!message) return null;
    return <div className="result-hint">{message}</div>;
  };
  const formatNumber = (value, digits = 2) => (value || value === 0 ? Number(value).toFixed(digits) : 'N/A');
  const formatPropertyValue = (key, value, digits = 2) => {
    const supported = isPropertySupported(key);
    if (supported && value !== null && value !== undefined) {
      return Number(value).toFixed(digits);
    }
    return 'N/A';
  };
  const renderPhaseVolume = () => {
    const supported = prediction?.availability?.phase_volume?.supported;
    if (!supported || !prediction?.phase_volume) {
      return <div className="phase-volume-empty">N/A</div>;
    }
    const topPhases = Object.entries(prediction.phase_volume)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 3);
    return (
      <div className="phase-volume-list">
        {topPhases.map(([phase, prob]) => (
          <div key={phase} className="phase-line">
            <span className="phase-name">{phase}</span>
            <span className="phase-prob">{(prob * 100).toFixed(1)}%</span>
          </div>
        ))}
      </div>
    );
  };

  const convertAtomicToWeight = (atomicComp) => {
    let total = 0;
    const weighted = {};
    Object.entries(atomicComp).forEach(([element, value]) => {
      const mass = ELEMENT_INFO[element]?.mass;
      if (!mass || value <= 0) return;
      const weightedValue = value * mass;
      weighted[element] = weightedValue;
      total += weightedValue;
    });
    if (!total) return { ...atomicComp };
    return Object.fromEntries(
      Object.entries(weighted).map(([element, value]) => [element, (value / total) * 100])
    );
  };

  const convertWeightToAtomic = (weightComp) => {
    let total = 0;
    const moles = {};
    Object.entries(weightComp).forEach(([element, value]) => {
      const mass = ELEMENT_INFO[element]?.mass;
      if (!mass || value <= 0) return;
      const moleValue = value / mass;
      moles[element] = moleValue;
      total += moleValue;
    });
    if (!total) return { ...weightComp };
    return Object.fromEntries(
      Object.entries(moles).map(([element, value]) => [element, (value / total) * 100])
    );
  };

  // 动态加载 Plotly
  const loadPlotly = async () => {
    if (window.Plotly) return window.Plotly;
    
    // 如果 Plotly 不存在，动态加载
    const script = document.createElement('script');
    script.src = 'https://cdn.plot.ly/plotly-latest.min.js';
    document.head.appendChild(script);
    
    return new Promise((resolve) => {
      script.onload = () => resolve(window.Plotly);
    });
  };

  // 创建基于组分相似性的3D散点图
  const createComposition3DPlot = async (predictionData) => {
    const Plotly = await loadPlotly();
    
    const { yield_strength, uts, elongation, density, computed_density, composition_neighbors, composition } = predictionData;
    
    // 构建预测结果的详细成分信息
    const predictionCompositionStr = Object.entries(composition)
      .filter(([_, value]) => value > 0)
      .map(([elem, value]) => `${elem}: ${value.toFixed(2)}%`)
      .join('<br>');
    
    // 预测点数据
    const predictionTrace = {
      x: [yield_strength],
      y: [uts],
      z: [elongation],
      mode: 'markers',
      type: 'scatter3d',
      name: 'Prediction Result',
      marker: {
        size: 8,
        color: [density],
        colorscale: 'Viridis', // 改为与属性相似性图表相同的颜色方案
        showscale: false,
        symbol: 'diamond',
        line: {
          color: 'darkred',
          width: 2
        }
      },
      text: [predictionCompositionStr],
      customdata: [{
        density: density,
        computed_density: computed_density,
        process_condition: 'AI Prediction',
        test_condition: 'Predicted at room temperature',
        source: 'MATAI ML Model'
      }],
      hovertemplate:
        '<b>Prediction Result</b><br>' +
        '<b>Yield Strength:</b> %{x:.2f} MPa<br>' +
        '<b>Ultimate Tensile Strength:</b> %{y:.2f} MPa<br>' +
        '<b>Elongation:</b> %{z:.2f}%<br>' +
        '<b>Predicted Density:</b> %{customdata.density:.2f} g/cm³<br>' +
        '<b>Computed Density:</b> %{customdata.computed_density:.2f} g/cm³<br>' +
        '<b>Composition (at. %):</b><br>%{text}<br>' +
        '<b>Process Condition:</b> %{customdata.process_condition}<br>' +
        '<b>Test Condition:</b> %{customdata.test_condition}<br>' +
        '<b>Source:</b> %{customdata.source}<extra></extra>'
    };

    // 基于组分相似性的最近邻数据点
    const compositionNeighborTrace = {
      x: composition_neighbors.map(n => n.yield_strength),
      y: composition_neighbors.map(n => n.uts),
      z: composition_neighbors.map(n => n.elongation),
      mode: 'markers',
      type: 'scatter3d',
      name: 'Composition-based Neighbors',
      marker: {
        size: 6,
        color: composition_neighbors.map(n => n.density),
        colorscale: 'Viridis', // 改为与属性相似性图表相同的颜色方案
        showscale: true,
        colorbar: {
          title: {
            text: 'Density (g/cm³)',
            side: 'right',
            font: { size: 12 }
          }
        },
        opacity: 0.7
      },
      text: composition_neighbors.map(n => {
        const compositionStr = Object.entries(n.composition)
          .filter(([_, value]) => value > 0)
          .map(([elem, value]) => `${elem}: ${value.toFixed(2)}%`)
          .join('<br>');
        return compositionStr;
      }),
      customdata: composition_neighbors.map(n => ({
        density: n.density,
        process_condition: n.process_condition,
        test_condition: n.test_condition,
        source: n.source,
        distance: n.distance
      })),
      hovertemplate:
        '<b>Composition-based Neighbor</b><br>' +
        '<b>Yield Strength:</b> %{x:.2f} MPa<br>' +
        '<b>Ultimate Tensile Strength:</b> %{y:.2f} MPa<br>' +
        '<b>Elongation:</b> %{z:.2f}%<br>' +
        '<b>Density:</b> %{customdata.density:.2f} g/cm³<br>' +
        '<b>Aitchison Distance:</b> %{customdata.distance:.3f}<br>' +
        '<b>Composition (at. %):</b><br>%{text}<br>' +
        '<b>Process Condition:</b> %{customdata.process_condition}<br>' +
        '<b>Test Condition:</b> %{customdata.test_condition}<br>' +
        '<b>Source:</b> %{customdata.source}<extra></extra>'
    };

    const data = [predictionTrace, compositionNeighborTrace];

    const layout = {
      title: {
        text: 'Prediction vs Composition-based Neighbors (3D)',
        font: { size: 16 }
      },
      scene: {
        xaxis: { 
          title: {
            text: 'Yield Strength (MPa)',
            font: { size: 14 }
          }
        },
        yaxis: { 
          title: {
            text: 'Ultimate Tensile Strength (MPa)',
            font: { size: 14 }
          }
        },
        zaxis: { 
          title: {
            text: 'Elongation (%)',
            font: { size: 14 }
          }
        },
        camera: {
          eye: { x: 1.2, y: 1.2, z: 1.2 }
        }
      },
      margin: { l: 0, r: 0, b: 0, t: 50 },
      legend: {
        x: 0,
        y: 1,
        font: { size: 12 }
      }
    };

    const config = {
      displayModeBar: true,
      modeBarButtonsToRemove: ['pan2d', 'lasso2d'],
      responsive: true
    };

    Plotly.newPlot('compositionPlot3d', data, layout, config);
  };

  // 创建3D散点图
  const create3DPlot = async (predictionData) => {
    const Plotly = await loadPlotly();
    
    const { yield_strength, uts, elongation, density, computed_density, nearest_neighbors, composition } = predictionData;
    
    // 构建预测结果的详细成分信息
    const predictionCompositionStr = Object.entries(composition)
      .filter(([_, value]) => value > 0)
      .map(([elem, value]) => `${elem}: ${value.toFixed(2)}%`)
      .join('<br>');
    
    // 预测点数据
    const predictionTrace = {
      x: [yield_strength],
      y: [uts],
      z: [elongation],
      mode: 'markers',
      type: 'scatter3d',
      name: 'Prediction Result',
      marker: {
        size: 8, // 减小预测点大小
        color: [density], // 使用密度作为颜色值
        colorscale: 'Viridis', // 与真实数据点使用相同色阶
        showscale: false, // 不显示单独的颜色条
        symbol: 'diamond',
        line: {
          color: 'darkred',
          width: 2
        }
      },
      text: [predictionCompositionStr],
      customdata: [{
        density: density,
        computed_density: computed_density,
        process_condition: 'AI Prediction',
        test_condition: 'Predicted at room temperature',
        source: 'MATAI ML Model'
      }],
      hovertemplate:
        '<b>Prediction Result</b><br>' +
        '<b>Yield Strength:</b> %{x:.2f} MPa<br>' +
        '<b>Ultimate Tensile Strength:</b> %{y:.2f} MPa<br>' +
        '<b>Elongation:</b> %{z:.2f}%<br>' +
        '<b>Predicted Density:</b> %{customdata.density:.2f} g/cm³<br>' +
        '<b>Computed Density:</b> %{customdata.computed_density:.2f} g/cm³<br>' +
        '<b>Composition (at. %):</b><br>%{text}<br>' +
        '<b>Process Condition:</b> %{customdata.process_condition}<br>' +
        '<b>Test Condition:</b> %{customdata.test_condition}<br>' +
        '<b>Source:</b> %{customdata.source}<extra></extra>'
    };

    // 最近邻数据点（基于属性相似性）
    const neighborTrace = {
      x: nearest_neighbors.map(n => n.yield_strength),
      y: nearest_neighbors.map(n => n.uts),
      z: nearest_neighbors.map(n => n.elongation),
      mode: 'markers',
      type: 'scatter3d',
      name: 'Property-based Neighbors',
      marker: {
        size: 6, // 固定点大小
        color: nearest_neighbors.map(n => n.density),
        colorscale: 'Viridis',
        showscale: true,
        colorbar: {
          title: {
            text: 'Density (g/cm³)',
            side: 'right',
            font: { size: 12 }
          }
        },
        opacity: 0.7
      },
      text: nearest_neighbors.map(n => {
        const compositionStr = Object.entries(n.composition)
          .filter(([_, value]) => value > 0)
          .map(([elem, value]) => `${elem}: ${value.toFixed(2)}%`)
          .join('<br>');
        return compositionStr;
      }),
      customdata: nearest_neighbors.map(n => ({
        density: n.density,
        process_condition: n.process_condition,
        test_condition: n.test_condition,
        source: n.source,
        distance: n.distance
      })),
      hovertemplate:
        '<b>Property-based Neighbor</b><br>' +
        '<b>Yield Strength:</b> %{x:.2f} MPa<br>' +
        '<b>Ultimate Tensile Strength:</b> %{y:.2f} MPa<br>' +
        '<b>Elongation:</b> %{z:.2f}%<br>' +
        '<b>Density:</b> %{customdata.density:.2f} g/cm³<br>' +
        '<b>Distance:</b> %{customdata.distance:.3f}<br>' +
        '<b>Composition (at. %):</b><br>%{text}<br>' +
        '<b>Process Condition:</b> %{customdata.process_condition}<br>' +
        '<b>Test Condition:</b> %{customdata.test_condition}<br>' +
        '<b>Source:</b> %{customdata.source}<extra></extra>'
    };

    const data = [predictionTrace, neighborTrace];

    const layout = {
      title: {
        text: 'Prediction vs Property-based Neighbors (3D)',
        font: { size: 16 }
      },
      scene: {
        xaxis: { 
          title: {
            text: 'Yield Strength (MPa)',
            font: { size: 14 }
          }
        },
        yaxis: { 
          title: {
            text: 'Ultimate Tensile Strength (MPa)',
            font: { size: 14 }
          }
        },
        zaxis: { 
          title: {
            text: 'Elongation (%)',
            font: { size: 14 }
          }
        },
        camera: {
          eye: { x: 1.2, y: 1.2, z: 1.2 }
        }
      },
      margin: { l: 0, r: 0, b: 0, t: 50 },
      legend: {
        x: 0,
        y: 1,
        font: { size: 12 }
      }
    };

    const config = {
      displayModeBar: true,
      modeBarButtonsToRemove: ['pan2d', 'lasso2d'],
      responsive: true
    };

    Plotly.newPlot('plot3d', data, layout, config);
  };

  const handleElementSelect = (element) => {
    if (!AVAILABLE_ELEMENTS.includes(element)) return;
    
    setSelectedElements(prev => {
      const currentSelectedCount = Object.keys(prev).filter(elem => prev[elem]).length;
      const isCurrentlySelected = prev[element];
      
      // 如果要添加新元素，检查是否超过7个限制
      if (!isCurrentlySelected && currentSelectedCount >= 7) {
        setError('Maximum 7 elements allowed');
        return prev;
      }
      
      const newSelected = {
        ...prev,
        [element]: !prev[element]
      };
      
      // 如果取消选择元素，同时清除其组成值
      if (!newSelected[element]) {
        setComposition(prevComp => {
          const newComp = { ...prevComp };
          delete newComp[element];
          return newComp;
        });
      }
      
              // 清除之前的错误信息
        if (error === 'Maximum 7 elements allowed') {
          setError(null);
        }
      
      return newSelected;
    });
  };

  const handleCompositionChange = (element, value) => {
    const numValue = parseFloat(value) || 0;
    setComposition(prev => ({
      ...prev,
      [element]: numValue
    }));
  };

  const handleInputModeChange = (nextMode) => {
    if (nextMode === inputMode) return;
    setComposition(prev => (
      nextMode === 'weight' ? convertAtomicToWeight(prev) : convertWeightToAtomic(prev)
    ));
    setInputMode(nextMode);
    setError(null);
  };

  // 添加重置到默认值的函数
  const handleReset = () => {
    setSelectedElements(DEFAULT_ELEMENTS);
    setComposition(DEFAULT_ELEMENTS);
    setInputMode('atomic');
    setError(null);
  };

  // 修改清空函数
  const handleClearAll = () => {
    setSelectedElements({});
    setComposition({});
    setPrediction(null);
    setError(null);
  };

  useEffect(() => {
    const total = Object.values(composition).reduce((sum, val) => sum + val, 0);
    setTotalComposition(total);
  }, [composition]);

  const validateComposition = () => {
    const selectedCount = Object.keys(selectedElements).filter(elem => selectedElements[elem]).length;
    const totalValid = Math.abs(totalComposition - 100) < 0.01;
    return totalValid && selectedCount >= 3 && selectedCount <= 7;
  };

  const getElementCountError = () => {
    const selectedCount = Object.keys(selectedElements).filter(elem => selectedElements[elem]).length;
    if (selectedCount < 3) {
      return `At least 3 elements required (current: ${selectedCount})`;
    }
    if (selectedCount > 7) {
      return `Maximum 7 elements allowed (current: ${selectedCount})`;
    }
    return null;
  };

  const handlePredict = async () => {
    const selectedCount = Object.keys(selectedElements).filter(elem => selectedElements[elem]).length;
    
    if (selectedCount < 3) {
      setError('At least 3 elements required');
      return;
    }
    
    if (selectedCount > 7) {
      setError('Maximum 7 elements allowed');
      return;
    }
    
    if (Math.abs(totalComposition - 100) >= 0.01) {
      setError('Total composition must be 100%');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const compositionForModel = inputMode === 'weight'
        ? convertWeightToAtomic(composition)
        : composition;
      const response = await fetch('/api/predict', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ composition: compositionForModel }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Prediction request failed');
      }

      const result = await response.json();
      setPrediction(result);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="predictor-page">
      <div className="predictor-container">
        <div className="predictor-header">
          <h2>Alloy Property Prediction</h2>
          <p className="predictor-subtitle">Predict material properties based on alloy composition using AI models</p>
        </div>
        
        <div className="predictor-main">
          {/* Left Panel - Element Selection */}
          <div className="element-panel">
            <div className="panel-header">
              <h3>Select Elements</h3>
              <p className="panel-description">Click highlighted elements to add to alloy composition (need 3-7 elements)</p>
            </div>
            
            <div className="periodic-table-container">
              <div className="periodic-table">
                {PERIODIC_TABLE.map((row, rowIndex) => (
                  <div key={rowIndex} className="periodic-row">
                    {row.map((element, colIndex) => (
                      <div
                        key={`${rowIndex}-${colIndex}`}
                        className={`periodic-cell ${
                          element 
                            ? (AVAILABLE_ELEMENTS.includes(element) ? 'available' : 'unavailable') 
                            : 'empty'
                        } ${selectedElements[element] ? 'selected' : ''}`}
                        onClick={() => element && handleElementSelect(element)}
                        title={element ? `${element} - ${ELEMENT_INFO[element]?.name}` : ''}
                      >
                        {element && (
                          <>
                            <div className="element-number">{ELEMENT_INFO[element]?.number}</div>
                            <div className="element-symbol">{element}</div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Panel - Composition Input */}
          <div className="composition-panel">
            <div className="panel-header">
              <div className="composition-header">
                <h3>Composition Input ({INPUT_MODES[inputMode].label})</h3>
                <div className="composition-toggle" role="group" aria-label="Composition input mode">
                  <button
                    type="button"
                    className={`composition-toggle-button${inputMode === 'atomic' ? ' active' : ''}`}
                    onClick={() => handleInputModeChange('atomic')}
                  >
                    at.%
                  </button>
                  <button
                    type="button"
                    className={`composition-toggle-button${inputMode === 'weight' ? ' active' : ''}`}
                    onClick={() => handleInputModeChange('weight')}
                  >
                    wt.%
                  </button>
                </div>
              </div>
              <p className="panel-description">
                {inputMode === 'atomic'
                  ? 'Enter the atomic percentage for each element'
                  : 'Enter the weight percentage for each element'}
              </p>
            </div>
            
            <div className="composition-input-section">
              {Object.keys(selectedElements).filter(elem => selectedElements[elem]).length > 0 ? (
                <>
                  <div className="composition-grid">
                    {Object.keys(selectedElements).filter(elem => selectedElements[elem]).map(element => (
                      <div key={element} className="composition-item">
                        <label className="composition-label">
                          <span className="element-symbol-large">{element}</span>
                          <span className="element-name-small">{ELEMENT_INFO[element]?.name}</span>
                        </label>
                        <div className="input-wrapper">
                          <input
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            value={composition[element] || ''}
                            onChange={(e) => handleCompositionChange(element, e.target.value)}
                            placeholder="0.00"
                            className="composition-input"
                          />
                          <span className="input-unit">%</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <div className="composition-summary">
                    <div className={`total-composition ${validateComposition() ? 'valid' : 'invalid'}`}>
                      <span className="total-label">Total:</span>
                      <span className="total-value">{totalComposition.toFixed(2)}%</span>
                      {Math.abs(totalComposition - 100) >= 0.01 && (
                        <span className="total-error">Total composition must be 100%</span>
                      )}
                      {getElementCountError() && (
                        <span className="total-error">{getElementCountError()}</span>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                                  <div className="no-elements-selected">
                    <div className="no-elements-icon">⚗️</div>
                    <p>No elements selected</p>
                    <p className="no-elements-hint">Click on elements in the periodic table to start</p>
                  </div>
              )}
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="action-buttons">
              <button 
                className="predict-button primary"
                onClick={handlePredict}
                disabled={loading || Object.keys(selectedElements).filter(elem => selectedElements[elem]).length === 0 || !validateComposition()}
              >
                {loading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Predicting...
                  </>
                ) : (
                  'Start Prediction'
                )}
              </button>
              <button 
                className="reset-button secondary"
                onClick={handleReset}
              >
                Reset to Default
              </button>
              <button 
                className="clear-button secondary"
                onClick={handleClearAll}
                disabled={Object.keys(selectedElements).filter(elem => selectedElements[elem]).length === 0}
              >
                Clear All
              </button>
            </div>
          </div>
        </div>

        {/* Prediction Results */}
        {prediction && (
          <>
            <div className="results-panel">
              <div className="panel-header">
                <h3>Prediction Results</h3>
                <p className="panel-description">
                  Some properties may be unavailable for the current composition due to model training coverage.
                </p>
              </div>
              
              {prediction.feasibility_warning && (
                <div className="feasibility-warning">
                  <span className="feasibility-warning-icon">⚠️</span>
                  <span>{prediction.feasibility_warning}</span>
                </div>
              )}

              <div className="results-grid">
                <div className="result-card">
                  <div className="result-icon">⚖️</div>
                  <div className="result-content">
                    <div className="result-label">Density</div>
                    <div className="result-value">{formatPropertyValue('density', prediction.density, 3)}</div>
                    <div className="result-unit">g/cm³</div>
                    {renderPropertyHint('density')}
                  </div>
                </div>
                
                <div className="result-card">
                  <div className="result-icon">💪</div>
                  <div className="result-content">
                    <div className="result-label">Yield Strength</div>
                    <div className="result-value">{formatPropertyValue('yield_strength', prediction.yield_strength)}</div>
                    <div className="result-unit">MPa</div>
                    {renderPropertyHint('yield_strength')}
                  </div>
                </div>
                
                <div className="result-card">
                  <div className="result-icon">🔧</div>
                  <div className="result-content">
                    <div className="result-label">Ultimate Tensile Strength</div>
                    <div className="result-value">{formatPropertyValue('uts', prediction.uts)}</div>
                    <div className="result-unit">MPa</div>
                    {renderPropertyHint('uts')}
                  </div>
                </div>
                
                <div className="result-card">
                  <div className="result-icon">📏</div>
                  <div className="result-content">
                    <div className="result-label">Elongation</div>
                    <div className="result-value">{formatPropertyValue('elongation', prediction.elongation)}</div>
                    <div className="result-unit">%</div>
                    {renderPropertyHint('elongation')}
                  </div>
                </div>

                <div className="result-card">
                  <div className="result-icon">🧱</div>
                  <div className="result-content">
                    <div className="result-label">Bulk Modulus (BM)</div>
                    <div className="result-value">{formatPropertyValue('bm', prediction.bm)}</div>
                    <div className="result-unit">GPa</div>
                    {renderPropertyHint('bm')}
                  </div>
                </div>

                <div className="result-card">
                  <div className="result-icon">🧵</div>
                  <div className="result-content">
                    <div className="result-label">Young&apos;s Modulus (EM)</div>
                    <div className="result-value">{formatPropertyValue('em', prediction.em)}</div>
                    <div className="result-unit">GPa</div>
                    {renderPropertyHint('em')}
                  </div>
                </div>

                <div className="result-card">
                  <div className="result-icon">🔄</div>
                  <div className="result-content">
                    <div className="result-label">Poisson Ratio</div>
                    <div className="result-value">{formatPropertyValue('poisson_ratio', prediction.poisson_ratio, 3)}</div>
                    <div className="result-unit">-</div>
                    {renderPropertyHint('poisson_ratio')}
                  </div>
                </div>

                <div className="result-card wide">
                  <div className="result-icon">🧊</div>
                  <div className="result-content">
                    <div className="result-label">Phase Volume (Top 3)</div>
                    <div className="result-value">
                      {renderPhaseVolume()}
                    </div>
                    <div className="result-unit">fraction</div>
                    {renderPropertyHint('phase_volume')}
                  </div>
                </div>
              </div>
            </div>

          </>
        )}

        <div className={`predictor-help${isHelpOpen ? '' : ' help-collapsed'}`}>
          <div className="help-header">
            <h3>How to Use the Predictor</h3>
            <button
              type="button"
              className="help-toggle-button"
              onClick={() => setIsHelpOpen(prev => !prev)}
              aria-expanded={isHelpOpen}
            >
              {isHelpOpen ? 'Hide' : 'Show'}
            </button>
          </div>
          {isHelpOpen && (
            <div className="help-content">
              <div className="help-step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Select Elements</h4>
                  <p>Click highlighted elements in the periodic table to add to alloy composition. Must select 3 to 7 elements.</p>
                </div>
              </div>
              <div className="help-step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Set Composition</h4>
                  <p>Choose atomic or weight percentage input and enter values for each selected element. Total composition must be 100%.</p>
                </div>
              </div>
              <div className="help-step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Get Prediction Results</h4>
                  <p>Click "Start Prediction" button to calculate density, yield strength, ultimate tensile strength and elongation, with data basis from real data.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PredictorPage; 
